import React, { useState, useEffect } from "react";
import { httpService } from "../../../base/services/httpService.service";
import ChatCard from "./ChatCard";
import ResolveTicketModal from "./ResolveTicketModal";
import { Link, useParams } from "react-router-dom";
import AuthService from "../../../../app/base/services/authentication.service";
import "./style.scss";
import { Button } from "antd";
import { convertTZ, formatDateString } from "../../../base/utils/timezoneConverter";
import { useTranslation } from "../../../i18n/LanguageContext";

const STATUS_META = {
   "Waiting For Response": { background: "#FFF9F0", color: "#FC9403" },
   Resolved: { background: "#EEF7F2", color: "#0E9349" }
};
const DEFAULT_STATUS_META = { background: "#DDE9FF", color: "#325899" };

function HelpDeskDetails() {
   const { t } = useTranslation();
   const { id } = useParams();
   const user = AuthService.getUser();
   const loggedInUser = user.fullName;
   const [data, setData] = useState([]);
   const [messages, setMessages] = useState([]);
   const [showResolveModal, setShowResolveModal] = useState(false);
   const isSuperAdmin = user.roles[0].name === "SuperAdmin";

   const getTicketById = async () => {
      try {
         await httpService.get(`Tickets/${id}`, (res) => {
            setData(res?.data);
            setMessages(res?.data?.messages);
         });
      } catch (error) {
         console.log(error);
      }
   };

   useEffect(() => {
      getTicketById();
   }, [id]);

   const statusMeta = STATUS_META[data?.status] || DEFAULT_STATUS_META;
   const statusLabel = data?.status === "Resolved" ? t("ticket-status-closed") : data?.status;

   const helpDeskListPath = isSuperAdmin ? "/admin/help-desk/list" : "/workspace/help-desk/list";

   return (
      <div className="ticket-preview-page">
         <div className="ticket-preview-breadcrumb">
            <Link to={helpDeskListPath}>
               {isSuperAdmin ? t("ticket-history-title") : t("help-desk-title")}
            </Link>
            <span> / {t("ticket-preview-title")}</span>
         </div>
         <p className="ticket-preview-title">{t("ticket-preview-title")}</p>

         <div className="ticket-preview-panels">
            <div className="ticket-summary-panel">
               <div className="ticket-summary-header">
                  <p>{t("ticket-summary-title")}</p>
               </div>
               <div className="ticket-summary-body">
                  <div className="ticket-summary-field">
                     <label>{t("status-column")}</label>
                     <span
                        className="ticket-status-wrapper"
                        style={{ background: statusMeta.background }}
                     >
                        <span className="ticket-status-dot" style={{ background: statusMeta.color }} />
                        <span style={{ color: statusMeta.color }}>{statusLabel}</span>
                     </span>
                     {isSuperAdmin && data?.status && data?.status !== "Resolved" && (
                        <Button
                           className="resolve-ticket-button"
                           onClick={() => setShowResolveModal(true)}
                        >
                           {t("mark-as-resolved-button")}
                        </Button>
                     )}
                  </div>
                  <div className="ticket-summary-field">
                     <label>{t("user-email-label")}</label>
                     <p>{data?.email}</p>
                  </div>
                  <div className="ticket-summary-field">
                     <label>{t("type-column")}</label>
                     <span className="ticket-type-pill">{data?.type}</span>
                  </div>
                  <div className="ticket-summary-field">
                     <label>{t("ticket-subject-label")}</label>
                     <p>{data?.subject}</p>
                  </div>
                  <div className="ticket-summary-field">
                     <label>{t("creation-date-column")}</label>
                     <p>{formatDateString(convertTZ(data?.submissionDate))}</p>
                  </div>
               </div>
            </div>
            <div className="ticket-chat-panel">
               <ChatCard
                  userName={data?.userName}
                  organizationName={data?.organizationName}
                  loggedInUser={loggedInUser}
                  getTicketById={getTicketById}
                  messages={messages}
               />
            </div>
         </div>
         <ResolveTicketModal
            visible={showResolveModal}
            onCancel={() => setShowResolveModal(false)}
            ticketId={id}
            getTicketById={getTicketById}
         />
      </div>
   );
}

export default HelpDeskDetails;
